"use client"

import { useRouter } from "@/lib/navigation"
import { useAuth } from "@/contexts/auth-context"
import { useEffect, useRef } from "react"

export default function PreloadPagesWrapper() {
  const router = useRouter()
  const { isAuthenticated, userType } = useAuth()
  const loadedType = useRef<string | null>(null)

  useEffect(() => {
    if (!isAuthenticated || !userType) return
    if (loadedType.current === userType) return
    loadedType.current = userType

    const adminPages = [
      "/admin/dashboard",
      "/admin/devices",
      "/admin/logs",
      "/admin/settings",
      "/admin/tasks",
      "/admin/users",
    ]
    const userPages = [
      "/user/dashboard",
    ]
    let pages: string[] = []
    if (userType === "admin") pages = adminPages
    if (userType === "user") pages = userPages

    pages.forEach((page) => {
      router.prefetch(page)
    })
  }, [isAuthenticated, userType, router])

  return null
} 